import { PointType } from './pointtype.enum';
import { ILocation, Location } from './location';
import { IDispatchPoint, DispatchPoint } from './dispatchpoint';
import { ILineItemModify, LineItemModify } from './lineItemmodify';

export class Modification {
    untilTime: Date;
    lineItems: Array<LineItemModify>;

    constructor(modification?: Modification) {
        this.untilTime = modification.untilTime;
        this.lineItems = new Array<LineItemModify>();
        for (let i = 0; i < modification.lineItems.length; i++) {
          this.lineItems.push(new LineItemModify(modification.lineItems[i]));
        }
    }
}